import { useState } from "react";

type StorageType = "localStorage" | "sessionStorage";

function useStorage<T>(storageType: StorageType, key: string, initialValue?: T) {
  const storageKey = (key: string) => `tenant:${key}`;

  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = window[storageType].getItem(storageKey(key));
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = (value: T | ((val: T) => T)) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (typeof window !== "undefined") {
        window[storageType].setItem(storageKey(key), JSON.stringify(valueToStore));
      }
    } catch (error) {}
  };
  return [storedValue, setValue] as const;
}

export default useStorage;
